/* eslint-disable */
!(function (t) {
  t.Redactor.prototype.limiter = function () {
    return {
      init: function () {
        this.opts.limiter &&
          this.core.getEditor().on(
            'keydown.redactor-plugin-limiter',
            t.proxy(function (t) {
              var e = t.which,
                i = t.ctrlKey || t.metaKey;
              if (
                !(
                  e === this.keyCode.BACKSPACE ||
                  e === this.keyCode.DELETE ||
                  e === this.keyCode.ESC ||
                  e === this.keyCode.SHIFT ||
                  (i && 65 === e) ||
                  (i && 82 === e) ||
                  (i && 116 === e)
                )
              ) {
                var r = this.core.getEditor().text();
                r = r.replace(/\u200B/g, '');
                var o = r.length;
                return !(o >= this.opts.limiter) && void 0;
              }
            }, this)
          );
      }
    };
  };
})(jQuery);
